// src/routes/ProtectedRoute.js
import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useNavigation } from "./utils/navigation";
import { AuthUserContext } from "./context/AuthUserContext";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import SimpleContext from "./context/SimpleContext";
import NotApprovedModal from "./components/popup/NotApprovedModal";

const ProtectedRoute = ({ children }) => {
  const { goToHome } = useNavigation();
  const { showLoginPopup } = useContext(SimpleContext);
  const { authTokens } = useContext(AuthUserContext);

  if (!authTokens) {
    showLoginPopup();
    return <Navigate to={goToHome()} replace />;
  }
  return children;
};
const ProtectedRouteVerification = ({ children }) => {
  const { authTokens } = useContext(AuthUserContext);
  const { setShowVerification } = useContext(SimpleContext);

  useEffect(() => {
    if (!authTokens?.access) return;

    const decoded = jwtDecode(authTokens.access);
    console.log("✅ Decoded token:", decoded);

    // if (decoded.is_verified === false) {
    //   setShowVerification(true);
    // } else {
    //   setShowVerification(false);
    // }
  }, [authTokens, setShowVerification]);

  return children;
};
const ProtectedRouteVerificationAndAdmin = ({ children }) => {
  const { authTokens, logoutUser } = useContext(AuthUserContext);
  const { setShowVerification } = useContext(SimpleContext);

  const [showNotApproved, setShowNotApproved] = useState(false);
  const [isApproved, setIsApproved] = useState(true); // Novo: da kontrolisemo da li sme da vidi children
  const navigate = useNavigate();

  useEffect(() => {
    if (!authTokens?.access) return;

    const decoded = jwtDecode(authTokens.access);

    // if (decoded.is_verified === false) {
    //   setShowVerification(true);
    // } else if (decoded.is_approved_by_admin === false) {
    //   setShowNotApproved(true);
    //   setIsApproved(false); // Ne prikazuj sadržaj
    // }
  }, [authTokens, setShowVerification]);

  const handleCloseModal = () => {
    setShowNotApproved(false);
    //navigate("/"); // Kada klikne "OK", vrati ga na početnu
    logoutUser();
  };

  if (showNotApproved) {
    return <NotApprovedModal onClose={handleCloseModal} />;
  }

  if (!isApproved) {
    return null; // Dok ne zatvori modal, ne prikazuj ništa
  }

  return children;
};

const ProtectedRouteSignUpIn = ({ children }) => {
  const { goToAccount } = useNavigation();
  const { authTokens } = useContext(AuthUserContext);

  if (authTokens) {
    return <Navigate to={goToAccount()} replace />;
  }
  return children;
};

const ProtectedAdmin = () => {
  const { authTokens, logoutUser } = useContext(AuthUserContext);
  const { setShowVerification } = useContext(SimpleContext);

  const [showNotApproved, setShowNotApproved] = useState(false);
  const [isApproved, setIsApproved] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authTokens?.access) return;

    const decoded = jwtDecode(authTokens.access);

    // if (decoded.is_verified === false) {
    //   setShowVerification(true);
    // } else if (decoded.is_approved_by_admin === false) {
    //   setShowNotApproved(true);
    //   setIsApproved(false);
    // }
  }, [authTokens, setShowVerification]);

  const handleCloseModal = () => {
    setShowNotApproved(false);
    logoutUser();
    window.location.reload();
  };

  if (showNotApproved) {
    return <NotApprovedModal onClose={handleCloseModal} />;
  }

  if (!isApproved) {
    return null;
  }

  // <Outlet/> će renderovati SVAKU podređenu <Route> koju stavimo unutar ovog wrappera
  return <Outlet />;
};

export default ProtectedRoute; // Podrazumevani eksport

export {
  ProtectedRouteSignUpIn,
  ProtectedRouteVerification,
  ProtectedRouteVerificationAndAdmin,
  ProtectedAdmin,
}; // Imenovani eksport
